import { useState, useEffect, useRef } from 'react';
import './Rewards.css';

const cards = [
  { emoji: '🦄', name: 'Licorne', rarity: 'Épique', unlocked: true },
  { emoji: '🐉', name: 'Dragon', rarity: 'Légendaire', unlocked: true },
  { emoji: '🐼', name: 'Panda', rarity: 'Rare', unlocked: true },
  { emoji: '🔒', name: 'Lvl 4', rarity: 'Héroïque', unlocked: true },
  { emoji: '🔒', name: 'Lvl 5', rarity: '???', unlocked: true },
];

const mascots = [
  { emoji: '🥚', name: 'Oeuf Magique', level: 1, xp: 140, maxXp: 750 },
  { emoji: '🐍', name: 'Evolution Serpent', level: 3, xp: 420, maxXp: 1000 },
  { emoji: '🐉', name: 'Evolution Dragon', level: 9, xp: 780, maxXp: 1000 },
];

export default function Rewards() {
  const [flipped, setFlipped] = useState(false);
  const [shaking, setShaking] = useState(false);
  const flippedRef = useRef(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!flippedRef.current) {
        setShaking(true);
        setTimeout(() => setShaking(false), 700);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleFlip = () => {
    if (flippedRef.current) return;
    flippedRef.current = true;
    setFlipped(true);
    setTimeout(() => {
      flippedRef.current = false;
      setFlipped(false);
    }, 10000);
  };

  return (
    <section className="rewards" id="recompenses">
      <div className="rewards__bg" />

      <div className="container">
        <div className="rewards__header">
          <div className="section-label">🏆 Récompenses</div>
          <h2 className="section-title">Des récompenses qui racontent une histoire</h2>
          <p className="section-subtitle">
            Pas de cadeaux matériels, pas de "pay to win". Des collections à débloquer et des mascottes à faire évoluer — Ce sont des marqueurs de progression qui devient ainsi visible et motivante pour l'enfant.  
          </p>
        </div>

        <div className="rewards__bento">

          {/* Block 1 — Collections */}
          <div className="rewards__block rewards__block--collections" style={{ '--block-color': '#F59E0B' }}>
            <div className="rewards__block-body">
              <div className="rewards__block-top">
                <div className="rewards__block-icon-wrap">
                  <span className="rewards__block-icon">🎴</span>
                </div>
                <span className="rewards__block-badge">COLLECTIONS</span>
              </div>
              <h3 className="rewards__block-title">Collections de cartes</h3>
              <p className="rewards__block-desc">Quand l'enfant franchit un palier, il peut découvrir une carte — un instant de magie que vous lirez dans ses yeux ! 10 cartes par collection (dont une finale animée) · Déblocage progressif. <p>Possibilité de commander les cartes au format papier dans la boutique de l'app, pour prolonger l'expérience. Elles peuvent alors servir de jeu pour les enfants (batailles, familles, etc.)</p></p>

              {/* Mini cards preview */}
              <div className="rewards__cards-row">
                {cards.map((card, i) => (
                  <div key={i} className={`rewards__mini-card${!card.unlocked ? ' rewards__mini-card--locked' : ''}`}>
                    <span className="rewards__mini-card-emoji">{card.unlocked ? card.emoji : '🔒'}</span>
                    <small className="rewards__mini-card-name">{card.name}</small>
                  </div>
                ))}
              </div>

              <ul className="rewards__tags">
                <li>🎴 Déblocage progressif</li>
                <li>✨ Moment de découverte</li>
                <li>🃏 Raretés variées</li>
              </ul>
            </div>
          </div>

          {/* Block 2 — Carte qui se retourne */}
          <div className="rewards__block rewards__block--reveal">
            <div className="rewards__reveal-body">
              <span className="rewards__block-badge">✨ INSTANT MAGIE</span>

              <div className="rewards__flip-scene">

                <div
                  className={`rewards__flip-card${flipped ? ' rewards__flip-card--flipped' : ''}${shaking && !flipped ? ' rewards__flip-card--shake' : ''}`}
                  onClick={handleFlip}
                >
                  <div className="rewards__flip-face rewards__flip-face--back">
                    <img src="/images/pinkheart-00.png" alt="Carte mystère" />
                  </div>
                  <div className="rewards__flip-face rewards__flip-face--front">
                    <img src="/images/pinkheart-01.png" alt="Pink Heart dévoilée" />
                  </div>
                </div>
              </div>

              <div className="rewards__flip-info">
                <h3 className="rewards__flip-title">Un palier franchi…</h3>
                <p className="rewards__flip-sub">une carte se révèle !</p>
              </div>
            </div>
          </div>

          {/* Block 3 — Mascottes */}
          <div className="rewards__block" style={{ '--block-color': '#9B59F5' }}>
            <div className="rewards__block-body">
              <div className="rewards__block-top">
                <div className="rewards__block-icon-wrap">
                  <span className="rewards__block-icon">🐾</span>
                </div>
                <span className="rewards__block-badge">MASCOTTES</span>
              </div>
              <h3 className="rewards__block-title">Mascottes évolutives</h3>
              <p className="rewards__block-desc">Elles grandissent avec l'enfant. Choix libre, progression visible — l'enfant décide qui il veut faire évoluer.</p>

              {/* Mascots list */}
              <div className="rewards__mascots-list">
                {mascots.map((m, i) => (
                  <div key={i} className="rewards__mascot-row">
                    <span className="rewards__mascot-emoji">{m.emoji}</span>
                    <div className="rewards__mascot-info">
                      <div className="rewards__mascot-top">
                        <span className="rewards__mascot-name">{m.name}</span>
                        <span className="rewards__mascot-level">Niv. {m.level}</span>
                      </div>
                      <div className="rewards__mascot-bar">
                        <div className="rewards__mascot-fill" style={{ '--bar-fill': `${(m.xp / m.maxXp) * 100}%` }} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <ul className="rewards__tags">
                <li>🐾 Choix libre</li>
                <li>📈 Progression visible</li>
                <li>🌟 Évolutions multiples</li>
              </ul>
            </div>
          </div>

          {/* Block 3 — Le moment du choix (full-width) */}
          <div className="rewards__block rewards__block--choice" style={{ '--block-color': '#FF6B4A' }}>
            <div className="rewards__choice-lead">
              <div className="rewards__block-icon-wrap">
                <span className="rewards__block-icon">🎉</span>
              </div>
              <div className="rewards__choice-text">
                <span className="rewards__block-badge">LE MOMENT DU CHOIX</span>
                <h3 className="rewards__block-title">C'est lui qui décide</h3>
                <p className="rewards__block-desc">Quand l'enfant franchit un palier d'XP, il choisit librement : débloquer une nouvelle carte ou faire évoluer sa mascotte. Ce moment de choix lui appartient — et c'est ce qui le rend si intéressant.</p>
              </div>
            </div>
            <div className="rewards__choice-buttons">
              <div className="rewards__choice-btn">
                <span className="rewards__choice-btn-icon">🎴</span>
                <span className="rewards__choice-btn-label">Nouvelle carte</span>
              </div>
              <div className="rewards__choice-or">ou</div>
              <div className="rewards__choice-btn">
                <span className="rewards__choice-btn-icon">🐾</span>
                <span className="rewards__choice-btn-label">Faire évoluer<br />ma mascotte</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
